var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8557 12.6758C17.505 13.1025 16.8748 13.1641 16.4482 12.8134L10.365 7.81336C9.93836 7.46267 9.87677 6.83251 10.2275 6.40585C10.5781 5.9792 11.2083 5.91761 11.635 6.2683L17.7181 11.2683C18.1448 11.619 18.2064 12.2492 17.8557 12.6758Z",
    fill: "#0077C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2275 17.6758C9.87677 17.2491 9.93835 16.619 10.365 16.2683L16.4481 11.2683C16.8747 10.9176 17.5049 10.9792 17.8556 11.4058C18.2063 11.8325 18.1447 12.4627 17.718 12.8133L11.635 17.8133C11.2083 18.164 10.5782 18.1025 10.2275 17.6758Z",
    fill: "#0077C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 11.4477 6.44772 11 7 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H7C6.44771 13 6 12.5523 6 12Z",
    fill: "#0077C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/ArrowForward.e4ed22f56c80e2ceb3a61ae20fdaef4c.svg";
export { ForwardRef as ReactComponent };